enum CardRequestType {
  POLICY_UPDATE = "POLICY_UPDATE",
  NEW = "NEW",
  REPLACE_LOST = "REPLACE_LOST",
  REPLACE_STOLEN = "REPLACE_STOLEN",
  REPLACE_DAMAGED = "REPLACE_DAMAGED",
  REPLACE_EXPIRED = "REPLACE_EXPIRED",
  LIMIT_INCREASE = "LIMIT_INCREASE",
  APPROVE_MERCHANT = "APPROVE_MERCHANT",
}

export default CardRequestType;
